import getActionsByDocument from '../../../../components/logs/actions';

const DOCUMENT = 'HOLIDAY_PRICING_LOGS_';

export default getActionsByDocument(DOCUMENT);
